import React from 'react';
import { Table, Empty } from 'antd';
import MovimientoInventarioValorizadoTable from './MovimientoInventarioValorizadoTable';
export default class ProductoInventarioValorizadoTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return (
            <Table
                className={'logistica-table-inventario-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.id}
               onExpand={async (expanded, record) => {
                   
                    await this.props.onSearchInventarioValorizadoMovimiento(record);
                }}
                expandedRowRender={(record) => {
                    return (
                        <div style={{ margin: '10px 0px' }}>
                            <MovimientoInventarioValorizadoTable dataSource={record.movimientos} />
                        </div>
                    )
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        title: 'Producto',
                        dataIndex: 'nombre',
                        key: 'nombre'
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'unidadMedida',
                        className: 'child-group',
                        key: 'unidadMedida'
                    },
                    {
                        title: 'Cantidades',
                        className: 'parent-group',
                        children: [
                            {
                                title: 'Saldo Inicial',
                                dataIndex: 'saldoInicialCantidad',
                                key: 'saldoInicialCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Ingresos',
                                dataIndex: 'ingresoCantidad',
                                key: 'ingresoCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Salidas',
                                dataIndex: 'salidaCantidad',
                                key: 'salidaCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Saldo Final',
                                dataIndex: 'saldoFinalCantidad',
                                key: 'saldoFinalCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            }
                        ]
                    },
                    {
                        title: 'Montos',
                        className: 'parent-group',
                        children: [
                            {
                                title: 'Saldo Inicial',
                                dataIndex: 'saldoInicialMonto',
                                key: 'saldoInicialMonto',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Ingresos',
                                dataIndex: 'ingresoMonto',
                                key: 'ingresoMonto',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Salidas',
                                dataIndex: 'salidaMonto',
                                key: 'salidaMonto',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Saldo Final',
                                dataIndex: 'saldoFinalMonto',
                                key: 'saldoFinalMonto',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            }
                        ]
                    },
                    // ,
                    // {
                    //     title: 'Precio Promedio',
                    //     dataIndex: 'precioPromedio',
                    //     key: 'precioPromedio',
                    //     className: 'child-group',
                    //     align: 'right',
                    //     render: (data) => (
                    //         <span>{data.toFixed(3)}</span>
                    //     )
                    // },
                ]}
            />
        );
    }
}